import"./StrikeText.css.ts.vanilla.css";var t={container:"StrikeText_styles_container__rkpz4f0",strike:"StrikeText_styles_strike__rkpz4f1",defaultStrike:"StrikeText_styles_defaultStrike__rkpz4f2"};export{t as styles};
//# sourceMappingURL=StrikeText.css.vanilla.js.map
